// extracted by mini-css-extract-plugin
export default {"modal":"modal-x_IBR1","left":"left-Nxauus","right":"right-ALn361","title":"title-k5Byxg","content":"content-AGGmR0","end":"end-wsYXmT"};